import React from "react";
import { TableCell, Table, TableHead, TableRow, TableBody, Button, Snackbar } from '@mui/material';
import RestUtilities, { IRestResponse } from '../../services/RestUtilities';
import Events from '../../models/Events';
import { RoutePaths } from '../../components/Routes'
import Auth from '../../services/Auth'
import GroupIcon from '@mui/icons-material/Group'
import PersonIcon from '@mui/icons-material/Person'
import Loader from '../../components/Loader'
import { GrowMessage } from "../../components/GrowMessage";
import { withRouter } from "../../components/Shared/withNavigate";
import AuthStore from '../../stores/Auth';

class CurrentEvents extends React.Component<any, any> {
    state = {
        events: [] as Events[],
        showError: false,
        errorMessage: '',
        loading: false
    }

    getColumnNames = (): string[] => {
        return ['Veranstaltung', 'Informationen', 'freie Plätze', 'Verfügbarkeit']
    }

    fetchEvents = (): void => {
        const currentDate: Date = new Date()
        const dateString: string = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()} ${currentDate.getHours()}:${currentDate.getMinutes()}`
        RestUtilities.get<Events[]>(`/api/ListActiveEvents?current=${dateString}`)
            .then(resp => {
                this.setState({ events: resp.content || [], loading: false })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    downloadAttachment = (id: number): void => {
        let url: string = `/api/EventAttachments?id=${id}`
    
    
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (xhr.response.size < 200) {
                        let reader = new FileReader()
                        reader.onload = () => {
                            let result = JSON.parse(reader.result as string)
                        }
                        reader.readAsText(this.response)
                        return false
                    }
                    let fileName: string = ''
                    let disposition = xhr.getResponseHeader('Content-Disposition')
    
                    if (disposition != null) {
                        let startIndex = disposition!.indexOf('filename=') + 9
                        fileName = disposition!.substring(21, disposition!.length)
                        fileName = fileName.replace(/['"]+/g, '')
                    }
    
                    let blob = new Blob([this.response])
                    RestUtilities.saveAs(blob, fileName)
    
                }
            }
        }
    
        xhr.open('GET', url)
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.setRequestHeader('Authorization',`Bearer ${AuthStore.getToken()}`);
        xhr.responseType = 'blob';
        xhr.send()
    }

    showError = (resp: IRestResponse<Events>): void => {
        if(typeof resp.error_content != 'undefined' && resp.error_content) {
            this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
        }
    }

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showError:false })
    }

    getAvailabilityIcon = (id: number): JSX.Element => {
        switch(id) {
            case 1: return <PersonIcon />
            case 2: return <GroupIcon />
            case 3: return <> <PersonIcon /> <GroupIcon /> </>
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        this.fetchEvents()
    }

    public render() {

        let rows = this.state.events.map(x => {
            return <TableRow key={x.id}>
                <TableCell>{x.eventName}</TableCell>
                <TableCell>
                    {
                        x.attachment !== null &&
                        <p 
                            style={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
                            onClick={() => this.downloadAttachment(x.attachment.id)}
                        >
                            {x.attachment.attachmentFilename}
                        </p>
                    }
                </TableCell>
                <TableCell>{x.maxMembersCount !== null ? `${x.maxMembersCount - x.currentMembersCount} von ${x.maxMembersCount}`: ''}</TableCell>
                <TableCell>
                    {this.getAvailabilityIcon(x.availabilityId)}
                </TableCell>
                {
                    Auth.isSignedIn() 
                        && (((x.maxMembersCount - x.currentMembersCount) > 0 || x.maxMembersCount == null)) &&
                    <TableCell>
                            <Button
                            className='btn btnBlue'
                            variant='contained'
                            color='primary'
                            onClick={() => this.props.router.navigate(`${RoutePaths.AddBookingUser}?eventId=${x.id}`)}>Anmelden</Button>
                    </TableCell>
                }
            </TableRow>
        })

        const columnNames: string[] = this.getColumnNames()

        if(Auth.isSignedIn())
            columnNames.push('Aktionen')
            
        let tableColumns = columnNames.map(x => {
            return <TableCell key={x}>{x}</TableCell>
        })

        return (
            <>
                <div className='row'>
                    <h2 className='title col-lg-12 col-md-12 col-sm-12 col-xs-12'>Aktuelle Betriebsratsveranstaltungen</h2>
                </div>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12' style={{ overflowX: 'auto' }}>
                        <Table className="objects-table table">
                            <TableHead>
                                <TableRow>
                                    {tableColumns}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows}
                            </TableBody>
                        </Table>
                    </div>
                </div>

                <GrowMessage
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    message={this.state.errorMessage}
                    visible={this.state.showError}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                ></GrowMessage>  
                {this.state.loading && <Loader />}
            </>
        )
    }
}

export default withRouter(CurrentEvents);